import request from '../utils/request'

import service from '../config/services';

import { countriesStore, dictDataStore } from '../utils/storage/tour.store'


const { domain: { tour } } = service;

//产品列表
export function getProductList(data) {
    return request({
        url: `${tour}/front/api/product/page`,
        method: 'get',
        params: data
    })
}

//产品详情
export function getProductInfo(data) {
    return request({
        url: `${tour}/front/api/product/get/info`,
        method: 'get',
        params: data
    })
}

//产品分类列表
export function getProductTypes(data) {
    return request({
        url: `${tour}/front/api/product/get/type/selector`,
        method: 'get',
        params: data
    })
}


//email注册
export function emailRegister(data) {
    return request({
        url: `${tour}/front/api/account/register`,
        method: 'post',
        data
    })
}

//登录
export function loginAction(data) {
    return request({
        url: `${tour}/front/api/account/login`,
        method: 'post',
        data
    })
}

//注册并登录
export function autoRegisterLoginAction(data) {
    return request({
        url: `${tour}/front/api/account/autoRegistAndlogin`,
        method: 'post',
        data
    })
}

//登录
export function loginByToken(data) {
    return request({
        url: `${tour}/front/api/account/loginByToken`,
        method: 'post',
        data
    })
}
//退出登录
export function logoutAction(data) {
    return request({
        url: `${tour}/front/api/account/logOut`,
        method: 'get',
        params: data
    })
}

//自动注册登录
export function autoRegistAndlogin(data) {
    return request({
        url: `${tour}/front/api/account/autoRegistAndlogin`,
        method: 'post',
        data
    })
}

//获取字典
export function getDictData(data, hideError = true) {
    return request({
        url: `${tour}/front/api/dict/get/selector`,
        method: 'get',
        params: data,
        cacheData: dictDataStore,
        hideError
    })
}


//订单详情
export function createOrder(data) {
    return request({
        url: `${tour}/front/api/order/booking`,
        method: 'post',
        data
    })
}

//订单列表
export function getOrderList(data) {
    return request({
        url: `${tour}/front/api/order/list`,
        method: 'get',
        params: data
    })
}
//订单详情
export function getOrderInfo(data) {
    return request({
        url: `${tour}/front/api/order/info`,
        method: 'get',
        params: data
    })
}


//资源价格
export function getResourceInventory(data) {
    return request({
        url: `${tour}/front/api/productPackageResourceInventory/getAllProductPackageResourceInventory`,
        method: 'get',
        params: data
    })
}

//发起支付
export function initOrderPay(data) {
    return request({
        url: `${tour}/front/api/orderPay/initPay`,
        method: 'get',
        params: data
    })
}

//退款
export function refundOrderPay(data) {
    return request({
        url: `${tour}/front/api/orderPay/refund`,
        method: 'get',
        params: data
    })
}

//获取取消原因
export function getCancelReasons(data) {
    return request({
        url: `${tour}/front/api/dict/get/order/cancel/reason`,
        method: 'get',
        params: data
    })
}

//取消订单
export function cancelOrder(data) {
    return request({
        url: `${tour}/front/api/order/cancel`,
        method: 'post',
        data
    })
}

//获取国家码
export function getCountryCode(data, hideError = true) {
    return request({
        url: `${tour}/front/api/dict/get/countryCode`,
        method: 'get',
        params: data,
        cacheData: countriesStore,
        hideError
    })
}

//获取产品规则
export function getProductRuleInfo(data, hideError = true) {
    return request({
        url: `${tour}/front/api/product/get/rule/info`,
        method: 'get',
        params: data,
        hideError
    })
}

//获取系统时间
export function getSystemTime(data, hideError = true) {
    return request({
        url: `${tour}/front/api/system/get/systemTime`,
        method: 'get',
        params: data,
        hideError
    })
}
//获取系统时间
export function getSystemDefault(data, hideError = true) {
    return request({
        url: `${tour}/front/api/system/get/systemDefault`,
        method: 'get',
        params: data,
        hideError
    })
}

//获取产品类型
export function getProductRuleTypes(data, hideError = true) {
    return request({
        url: `${tour}/front/api/product/get/rule/type/selector`,
        method: 'get',
        params: data,
        hideError
    })
}

//重置密码
export function resetPassword(data) {
    return request({
        url: `${tour}/front/api/account/update/password`,
        method: 'get',
        params: data
    })
}